import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { PageHeader, Btn, Input, Field, Select } from "@/components/erp/ui";
import { MediaInput, BACKEND } from "@/components/erp/prod/ProdInputs";
import { useFlow, WoHead, Denied, err, uploadFlow, Thumbs } from "@/components/erp/flow/FlowCommon";
import { FileText } from "lucide-react";

const openPdf = async (wid) => {
  try { const r = await api.get(`/flow/${wid}/surat-jalan.pdf`, { responseType: "blob" }); window.open(URL.createObjectURL(r.data), "_blank"); } catch (e) { err(e); }
};

const ShipCard = ({ w, load }) => {
  const s = w.shipping;
  const [v, setV] = useState({ method: s.method || "COURIER", courier: s.courier || "", driver: s.driver || "", address: w.address || "" });
  const [p, setP] = useState({ resi: "", photos: [], received_by: "" });
  const mk = async () => { try { await api.post(`/flow/${w.wo_id}/shipping`, v); toast.success("Surat jalan dibuat"); load(); } catch (e) { err(e); } };
  const done = async () => { try { await api.post(`/flow/${w.wo_id}/shipping/proof`, p); toast.success("Unit diterima — WO selesai"); load(); } catch (e) { err(e); } };
  return (
    <div>
      <div className="text-xs text-slate-500 mb-2">Packing: {w.packing.by} · {w.packing.at?.slice(0, 16).replace("T", " ")}{w.packing.invoice_included ? " · invoice di dalam" : ""}</div>
      <Thumbs paths={[...(w.packing.inner_photos || []), ...(w.packing.outer_photos || [])]} />
      <div className="grid sm:grid-cols-4 gap-2 mt-3">
        <Field label="Metode"><Select data-testid={`ship-method-${w.wo_code}`} value={v.method} onChange={(e) => setV({ ...v, method: e.target.value })}>
          <option value="COURIER">Ekspedisi / kurir</option><option value="ANTAR">Diantar tim</option><option value="PICKUP">Diambil customer</option></Select></Field>
        <Field label="Ekspedisi / kendaraan"><Input data-testid={`ship-courier-${w.wo_code}`} value={v.courier} onChange={(e) => setV({ ...v, courier: e.target.value })} /></Field>
        <Field label="Driver / PJ"><Input data-testid={`ship-driver-${w.wo_code}`} value={v.driver} onChange={(e) => setV({ ...v, driver: e.target.value })} /></Field>
        <Field label="Alamat"><Input value={v.address} onChange={(e) => setV({ ...v, address: e.target.value })} /></Field>
      </div>
      <div className="flex flex-wrap gap-2 mt-2">
        <Btn variant={s.delivery_id ? "ghost" : "primary"} data-testid={`ship-create-${w.wo_code}`} onClick={mk}>{s.delivery_id ? "Perbarui surat jalan" : "Buat surat jalan / BAST"}</Btn>
        {s.delivery_id && <Btn variant="ghost" data-testid={`ship-pdf-${w.wo_code}`} onClick={() => openPdf(w.wo_id)}><FileText className="w-4 h-4" /> {s.sj_code}</Btn>}
        {w.invoice && <a className="text-xs text-sky-700 underline self-center" target="_blank" rel="noreferrer" href={`${BACKEND}/api/public/invoice/${w.invoice.id}/termin/0/pdf`}>Invoice {w.invoice.code}</a>}
      </div>
      {s.delivery_id && (
        <div className="mt-3 rounded-xl bg-slate-50 p-3" data-testid={`ship-proof-${w.wo_code}`}>
          <div className="grid sm:grid-cols-2 gap-2">
            {v.method === "COURIER" && <Field label="No. resi"><Input data-testid={`ship-resi-${w.wo_code}`} value={p.resi} onChange={(e) => setP({ ...p, resi: e.target.value })} /></Field>}
            <Field label="Diterima oleh"><Input data-testid={`ship-recv-${w.wo_code}`} value={p.received_by} onChange={(e) => setP({ ...p, received_by: e.target.value })} /></Field>
          </div>
          <div className="mt-2"><MediaInput value={p.photos} onChange={(x) => setP({ ...p, photos: x })} max={4} uploader={uploadFlow} testid={`ship-photos-${w.wo_code}`} label="Foto bukti resi / serah terima unit" /></div>
          <Btn className="mt-2" data-testid={`ship-done-${w.wo_code}`} disabled={!p.photos.length} onClick={done}>Unit sudah diterima</Btn>
        </div>
      )}
    </div>
  );
};

export default function ShippingDashboard() {
  const { d, load, denied } = useFlow("SHIP");
  if (denied) return <Denied />;
  if (!d) return <div className="p-6 text-sm text-slate-400">Memuat…</div>;
  return (
    <div data-testid="shipping-page">
      <PageHeader title="Dashboard Pickup & Pengiriman" subtitle="Surat jalan / BAST terhubung invoice · bukti resi atau serah terima unit" />
      <div className="space-y-3">{d.wos.map((w) => <WoHead key={w.wo_id} w={w}><ShipCard w={w} load={load} /></WoHead>)}</div>
      {!d.wos.length && <p className="text-sm text-slate-400" data-testid="ship-empty">Belum ada unit yang siap dikirim.</p>}
    </div>
  );
}
